<div class="container mt-3 d-flex flex-column" style="height: 82vh; overflow: hidden;">
  <!-- Search -->
  <div class="mb-3">
    <input type="text" class="form-control form-control-sm" id="searchBookmark" [(ngModel)]="searchQuery"
      placeholder="Search for a bookmark..." (input)="filterBookmarks()" />
  </div>

  <!-- Scrollable list wrapper -->
  <ng-container *ngIf="isLoading; else listTpl">
    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
      <div class="spinner-grow text-danger" role="status">
        <span role="status" aria-hidden="true"></span>
      </div>
    </div>
  </ng-container>

  <ng-template #listTpl>
    <div class="bookmark-list-wrapper flex-grow-1 overflow-auto">
      <!-- If there are any filtered bookmarks, show the list -->
      <ng-container *ngIf="filteredBookmarks.length > 0; else noBookmarks">
        <ul class="list-group mb-0">
          <li class="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
            *ngFor="let bm of filteredBookmarks" [ngClass]="{'active-route': bm === selectedBookmark}"
            [class.text-muted]="bm.visibility==='Public' && bm.createdById !== currentUserId"
            [title]="bm.visibility==='Public' && bm.createdById !== currentUserId ? 'Public bookmark — view only' : ''"
            (click)="loadBookmark(bm)">
            <div class="d-flex align-items-center">
              <span class="bookmark-name" [title]="bm.bookmarkName">
                {{ bm.bookmarkName }}
              </span>
              <span *ngIf="bm.isDefault" class="badge rounded-pill bg-secondary ms-2"
                title="This is your default bookmark">
                Default
              </span>
              <mat-icon *ngIf="bm.visibility==='Public'" class="ms-2" style="color: red;" aria-label="Public bookmark">
                public
              </mat-icon>
            </div>
          </li>
        </ul>
      </ng-container>

      <!-- Template for “no results” -->
      <ng-template #noBookmarks>
        <div class="py-3 text-center text-muted">
          No bookmarks found
          <span *ngIf="searchQuery"> for "<strong>{{ searchQuery }}</strong>"</span>.
        </div>
      </ng-template>
    </div>
  </ng-template>




  <!-- messages -->
  <div *ngIf="successMessageVisible" class="alert alert-success mt-2">
    {{ successMessage }}
  </div>
  <div *ngIf="errorMessageVisible" class="alert alert-danger mt-2">
    {{ errorMessage }}
  </div>

  <!-- form or add-new button -->
  <ng-container *ngIf="isFormOpen; else addNewBtn">
    <div class="card-container mt-3">
      <div>
        <!-- Close Icon in the top-right corner -->
        <button type="button" class="close-btn" (click)="cancel()">
          <i class="fa fa-times"></i> <!-- Close icon -->
        </button>

        <div class="mt-4">
          <input type="text" class="form-control form-control-sm w-100" id="bookmarkLabel"
            placeholder="Enter Bookmark Label" [(ngModel)]="bookmarkName" />
        </div>

        <div class="d-flex justify-content-start mt-3">
          <div class="form-check me-3">
            <input class="form-check-input" type="checkbox" id="default" [(ngModel)]="isDefault" />
            <label class="form-check-label mt-1" for="default">Default</label>
          </div>
          <div class="form-check" *ngIf="isGlobalAdmin">
            <input class="form-check-input" type="checkbox" id="public" [(ngModel)]="isPublic" />
            <label class="form-check-label mt-1" for="public">Public</label>
          </div>
        </div>

        <button type="button" class="btn btn-primary btn-sm w-100 mt-3 saveBtn" (click)="saveBookmark()"
          [disabled]="isSaving">
          <i class="fa fa-save"></i> {{ isSaving ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #addNewBtn>
    <button class="btn btn-primary btn-sm w-100 mt-3 saveBtn" (click)="openBookmarkForm()">
      <i class="fa fa-plus-circle"></i> Add New
    </button>
  </ng-template>
</div>